import React from "react";
import { Page, Text, View, Image } from "@react-pdf/renderer";

import { ADDRESS_TYPES } from "../../../constants/constants";
import CDK_Logo from "../../../images/CDKGlobalWM_BLK.jpg";
import Signature from "../../../images/Signature.png";
import styles from "../PDFStyles/SEZForm";
import {
  getAddressAsString,
  getFormattedDate,
  getFullName
} from "../../../util/helpers";
import { getFatherOrMotherOrSpouseName } from "../../../util/onBoardingDataFilters";

const SEZForm = ({ candidateDetails, states }) => {
  const {
    addresses,
    birthDate,
    cDKDesignation,
    dateofJoining,
    familyMembers,
    identificationMark,
    sezCardIsFatherOrMotherOrSpouse
  } = candidateDetails

  const fatherOrMotherOrSpouseName = getFatherOrMotherOrSpouseName(
    sezCardIsFatherOrMotherOrSpouse,
    familyMembers
  );

  return (
    <Page size="A4" style={styles.page}>
      <Image style={styles.cdkLogo} src={CDK_Logo} />
      <View style={styles.header}>
        <View style={styles.headerinfo}>
          <Text style={styles.title}>
            Application Form for Permanent/Temporary Identity Card
          </Text>
          <Text style={styles.boldItalicText}>
            (To be filled by the Applicant)
          </Text>
          <Text> </Text>
          <Text style={styles.boldText}>CDK Global (India) Pvt Ltd. </Text>
          <Text>(Special Economic Zone)</Text>
          <Text>5th Floor, Building No.12 B, Sundew Properties Ltd-SEZ, Madhapur,</Text>
          <Text>Raheja Mindspace, Hyderabad, Rangareddy, Telangana – 500 081.</Text>
        </View>
      </View>
      <View style={styles.table}>
        <View style={{ ...styles.tableRow, ...styles.boldText }}>
          <Text style={styles.tablecellLeft}>Name Of The Company/Unit</Text>
          <Text style={styles.tablecellRight}>
            CDK Global (India) Pvt. Ltd.
          </Text>
        </View>

        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>Name Of The Employee</Text>
          <Text style={styles.tablecellRight}>
            {getFullName(candidateDetails)}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>Designation</Text>
          <Text style={styles.tablecellRight}>
            {cDKDesignation}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>
            Father’s / Mother’s / Spouse's Name
          </Text>
          <Text style={styles.tablecellRight}>
            {fatherOrMotherOrSpouseName}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>Temporary Address</Text>
          <Text style={styles.tablecellRight}>
            {getAddressAsString(
              ADDRESS_TYPES.CURRENT,
              addresses,
              states
            )}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>Permanent Residence Address</Text>
          <Text style={styles.tablecellRight}>
            {getAddressAsString(
              ADDRESS_TYPES.PERMANENT,
              addresses,
              states
            )}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>Date of Birth</Text>
          <Text style={styles.tablecellRight}>
            {getFormattedDate(birthDate)}
          </Text>
        </View>
        <View style={styles.tableRow}>
          <Text style={styles.tablecellLeft}>Date of Joining</Text>
          <Text style={styles.tablecellRight}>
            {getFormattedDate(dateofJoining)}
          </Text>
        </View>
        <View style={styles.lastTableRow}>
          <Text style={styles.tablecellLeft}>Identification Mark</Text>
          <Text style={styles.tablecellRight}>
            {identificationMark}
          </Text>
        </View>
      </View>
      <View style={styles.details}>
        <View style={styles.signature}>
          <View style={styles.employeeSignature}>
            <Text style={styles.signatureName}>
              {getFullName(candidateDetails)}
            </Text>
            <Text>________________________________</Text>
            <Text style={styles.signatureSubText}>Signature of Employee</Text>
          </View>
          <View style={styles.cdkSignature}>
            <Image style={styles.signatureImage} src={Signature} />
            <Text>___________________________________________________</Text>
            <Text style={styles.signatureSubText}>
              Signature of Authorized Signatory
            </Text>
            <Text style={styles.headSignatureName}>(Rahul Shirodkar)</Text>
          </View>
        </View>

        <View style={styles.signatureLine} />

        <View style={styles.bottomText}>
          <Text style={styles.textCenter}> (For Office Use Only) </Text>
          <Text>
              Entry for
              Mr./Ms./Mrs._______________________________________________________________________________
            </Text>
            <Text>
              S/o / D/o / w/o /Shri_________________________________________________________has
              been made in the Register of 
            </Text>
            <View style={styles.bottomSubText}>
              <Text>
                M/s CDK Global (India) Pvt Ltd. (Special Economic
                Zone) 5th Floor, Building No.12 B, Sundew Properties
              </Text>
              <Text>
                Ltd-SEZ, Madhapur, Raheja Mindspace, Hyderabad, Rangareddy, Telangana at Sr.
                No.________________at Page No_________.Now Mr. / Ms. / Mrs._____________________
                 is allowed to get entry in M/s CDK Global (India) Pvt Ltd.
              </Text>
              <Text>
              (Special Economic Zone) by showing his Permanent identity Card, bearing
                No________________________.
              </Text>
          </View>

          <View style={styles.bottomSign}>
            <Text>_____________________________________________________</Text>
            <Text> (Signature of Development Commissioner)</Text>
          </View>
        </View>
      </View>
    </Page>
  );
};
export default SEZForm;
